import { render } from "./LiveScheduler.vue?vue&type=template&id=89b7bbf8&scoped=true"
import script from "./LiveScheduler.vue?vue&type=script&lang=js"
export * from "./LiveScheduler.vue?vue&type=script&lang=js"

import "./LiveScheduler.vue?vue&type=style&index=0&id=89b7bbf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b7bbf8"]])

export default __exports__